<div class="vincent_about2">
    <div class="row">
        <div class="col col-12 vincent_content">

            <div class="row vincent_reservation" style="flex-direction: row-reverse;">
                <div class="col col-12 vincent_reservation_block ">
                    <h1>{{"be_always_with_us" | translate}}</h1>
                    <img src="assets/imgs/separator_dark.png" alt="">
                    <p>{{"table_no_discrebtion" | translate}}</p>
                    <div class="vincent_form_block ">

                        <div class="row gutters">
                            <div class="col col-12">
                                <input name="tableno" type="number" class="form_user-name two-way-input" [(ngModel)]="tableno">
                            </div>
                        </div>

                        <input type="submit" class="default-btn-one custom-btn" value='{{"submit" | translate}}' (click)="updateNo(tableno)">

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>